<template>
    <div class="table">
        <div class="table_wrapper">
            <table>
                <thead>
                <tr>
                    <th v-if="withType" class="type">Type</th>
                    <th class="small">{{titled}}</th>
                    <th class="small">{{titled}} af</th>
                    <th v-if="hasPermission(['bansite.view.*','bansite.view.reason'])">Grund</th>
                    <th :class="{'small': hasPermission(['bansite.view.*','bansite.view.reason'])}">Dato</th>
                    <th class="small" v-if="type !== 'kicks'">Udløber</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="p in punishments">
                    <td class="col-type" v-if="withType">
                        <router-link :to="getGoToPunishment(p.id, p.type)">
                            <span :class="'badge badge-' + p.type.toLowerCase()">{{p.type}}</span>
                        </router-link>
                    </td>
                    <td class="col-user">
                        <router-link :to="getGoToPunishment(p.id, p.type)">
                            <div class="user">
                                <img :src="p.avatar" style="border-radius: 50%;">
                                <span>{{bannedName(p.name, p.discriminator, p.discord_id)}}</span>
                            </div>
                        </router-link>
                    </td>
                    <td class="col-staff">
                        <router-link :to="getGoToPunishment(p.id, p.type)">
                            <div class="user">
                                <img :src="p.banned_by_avatar" style="border-radius: 50%;">
                                <span>{{staffName(p.banned_by_name, p.banned_by_discriminator, p.banned_by_id, p.banned_by_nickname)}}</span>
                            </div>
                        </router-link>
                    </td>
                    <td class="col-reason">
                        <router-link :to="getGoToPunishment(p.id, p.type)"><span>{{p.reason === null || p.reason === undefined || p.reason.length === 0 ? "---" : p.reason}}</span>
                        </router-link>
                    </td>
                    <td class="col-time">
                        <router-link :to="getGoToPunishment(p.id, p.type)">
                            {{$utils.parseDate(p.time)}}
                        </router-link>
                    </td>
                    <td class="col-expire">
                        <router-link :to="getGoToPunishment(p.id, p.type)">
                            {{$utils.parseUntilDate(p.until)}}
                            <div v-if="$utils.isExpired(p.removed_by_name, p.until) === 1 || p.active.data[0] === 0"
                                 class="expired">(udløbet)
                            </div>
                            <div v-else-if="$utils.isExpired(p.removed_by_name, p.until) === 2" class="expired">
                                (un{{withType ? typeTitle(p.type).toLowerCase() : title.toLowerCase()}} af
                                {{p.removed_by_name}})
                            </div>
                        </router-link>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['punishments', 'with-type'],
        computed: {
            title() {
                let name = this.$utils.getPageType(this.$route.name).type;
                return name.substring(0, name.length - 1);
            },
            titled() {
                switch (this.type) {
                    case "kicks":
                        return "Kicked";
                    case "bans":
                        return "Banned";
                    case "mutes":
                        return "Muted";
                    case "names":
                        return "Banned";
                    default:
                        return "Straffet";
                }
            },
            type() {
                return this.$utils.getPageType(this.$route.name).type;
            },
        },
        methods: {
            bannedName(name, discriminator, id) {
                if (name === null) {
                    return id;
                }
                return name + '#' + discriminator;
            },
            staffName(name, discriminator, id, nickname) {
                if (nickname === null) {
                    if(name === null){
                        return id;
                    }
                    return name
                }
                return nickname;
            },
            typeTitle(type) {
                switch (type.toLowerCase()) {
                    case "kick":
                        return "Kicked";
                    case "ban":
                        return "Banned";
                    case "mute":
                        return "Muted";
                    default:
                        return "Straffet";
                }
            },
            hasPermission(perm) {
                return this.$api.getUser().hasPermission(perm);
            },
            getGoToPunishment(id, ptype) {
                let name = this.$route.name;
                if (this.type !== 'user' && this.type !== 'staff') {
                    name = name.substring(0, name.length - 1);
                } else {
                    name = 'discord_' + ptype.toLowerCase();
                }
                return {name: name, params: {id: id}};
            },
        },
    }
</script>

<style lang="scss" scoped>
    section {
        .pagination {
            display: flex;
            margin-top: 2rem;
            justify-content: center;
        }

        table {
            width: 100%;
            font-size: 16.5px;
            margin-bottom: 0;
            text-align: center;
            border-collapse: collapse;
            background-color: #343a40;

            thead {
                background: #262a2d;

                th {
                    vertical-align: middle;
                    overflow-wrap: break-word;
                    padding: .75rem;
                    font-weight: bold;

                    &.small {
                        width: 15%;
                    }

                    &.type {
                        width: 10%;
                    }
                }
            }

            tbody {
                tr {
                    background-color: rgba(0, 0, 0, .05);

                    &:nth-of-type(odd) {
                        background-color: hsla(0, 0%, 100%, .05);
                    }

                    td {
                        vertical-align: middle;
                        overflow-wrap: break-word;
                        padding: .75rem;

                        a {
                            color: #fff;
                            text-decoration: none;
                        }
                    }

                    .user {
                        img {
                            border-radius: 2px;
                            display: block;
                            margin: 0 auto;
                            vertical-align: middle;
                            padding-bottom: 5px;
                            height: 25px;
                        }
                    }

                    .expired {
                        padding-top: 5px;
                        font-style: italic;
                        font-size: 15px;
                        color: #878e94;
                        max-width: 100%;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    .badge {
                        padding: 10px 5px;
                        border-radius: 2px;
                        width: 65px;
                        text-transform: uppercase;
                        font-weight: bold;
                        letter-spacing: 1px;
                        display: inline-block;
                        text-align: center;

                        &.badge-nameban {
                            background-color: #1462a2;
                        }

                        &.badge-ban {
                            background-color: #a21414;
                        }

                        &.badge-kick {
                            background-color: #ce8720;
                        }

                        &.badge-mute {
                            background-color: #607d8b;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1400px) {
    }

    @media screen and (max-width: 990px) {
        table {
            thead {
                display: none;
            }

            tbody {
                tr {
                    padding: 10px 0;
                    display: block;
                }

                td {
                    position: relative;
                    width: 100%;
                    display: block;
                    text-align: left;

                    a {
                        padding-left: 35%;
                        display: block;
                    }

                    .user {

                        img {
                            padding-bottom: 0px;
                            padding-right: 5px;
                            display: inline !important;
                        }
                    }

                    &:before {
                        position: absolute;
                        width: 40%;
                        left: 10px;
                        top: 0;
                        padding: .75rem;
                    }

                    &.col-expire:before {
                        content: "Udløber";
                    }
                    &.col-time:before {
                        content: "Tidspunkt";
                    }
                    &.col-reason:before {
                        content: "Grund";
                    }
                    &.col-staff:before {
                        content: "Straffet af";
                    }
                    &.col-user:before {
                        content: "Straffet";
                    }
                    &.col-status:before {
                        content: "Status";
                    }
                    &.col-type:before {
                        content: "Type";
                    }
                }
            }
        }
    }

    @media screen and (max-width: 760px) {
    }

    @media screen and (max-width: 585px) {
    }
</style>
